define('controllers/hotelinvoices',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function () {
        $("form").on("submit", function (e) { e.preventDefault(); }); //key up in search causes page refresh, since it submits form
        var grid = CreateJohnGrid(),
            columns = [{ DataField: "InvoiceNumber", HeaderText: "Number" }, { DataField: "InvoiceDate", HeaderText: "Date" }],
            txtSearchTerm = $("#txtSearchTerm");

        grid.sorting.allowSorting = true;

        grid.onDataBinding = function () {
            grid.dsPostValues.HotelId = ServerData.feData.hotelId;
            grid.dsPostValues.SearchTerm = txtSearchTerm.val();
        };
        grid.init($("#tblInvoices"), columns, "Invoice_AJAX.aspx");
        $(".johnGridHeader", grid.$table).prepend($("#filterPanel"));
        grid.databind();

        txtSearchTerm.on("keyup", function () {
            grid.databind();
        });
    };
});

